module.exports = __webpack_public_path__ + "img/Breaking_Down_Applications_by_Business_Capabilities.e8448339.jpeg";